import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const ReportExecutionsTableViewReportExecutionFragmentDoc = gql`
  fragment ReportExecutionsTableViewReportExecution on ReportExecution {
    id
    reportNumber
    user {
      id
      fullName
    }
    status
    createdAt
    downloadUrl
  }
` as unknown as DocumentNode<Types.ReportExecutionsTableViewReportExecutionFragment, unknown>
